import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Card, Column, Icon, Overlay, Radio, Row } from '../index';
import { Button, LoadingIndicator } from '@cfa/react-components';

class VaultedCards extends React.Component {
  constructor(props) {
    super(props);
    this.state = { cardToDelete: {} };
    this.handleDeleteCard = this.handleDeleteCard.bind(this);
  }

  handleDeleteCard(card) {
    this.setState({ cardToDelete: card });
    this.props.deleteCard(card);
  }

  render() {
    const {
      vaultedCards,
      accountSelected,
      selectedAccount,
      openModal,
      deleteCardLoading,
      vaultedCardsLoading,
      addCardLoading,
    } = this.props;
    const buttonText = vaultedCards.length > 0 ? 'Add another credit card' : 'Add a credit card';
    const { cardToDelete } = this.state;
    return (
      <StyledVaultedCards>
        {addCardLoading && <Overlay />}
        {vaultedCardsLoading ? (
          <LoadingIndicator
            variant="inline"
            size="sm"
            className="loading"
            data-testid="vaulted-cards-loading"
          />
        ) : (
          <React.Fragment>
            <div className="charge-info">
              Your payment method may be charged up to 24 hours before your order is ready.
            </div>
            {vaultedCards.length > 0 ? (
              vaultedCards.map((card) => (
                <Row className="card-row" key={card.id}>
                  <Column xs="8" sm="5">
                    <label className="label" htmlFor={card.id}>
                      <Radio
                        id={card.id}
                        checked={selectedAccount.id === card.id}
                        onChange={() => accountSelected(card)}
                        disabled={card.isExpired}
                      />
                      <Column className="card-icon">
                        <Card expired={card.isExpired} card={card} />
                      </Column>
                    </label>
                  </Column>
                  <Column xs="4" sm="7">
                    {deleteCardLoading && cardToDelete.id === card.id ? (
                      <LoadingIndicator variant="inline" size="sm" data-testid="delete-card-loading" />
                    ) : (
                      <Button size="sm" className="remove" onClick={() => this.handleDeleteCard(card)}>
                        Remove
                      </Button>
                    )}
                  </Column>
                </Row>
              ))
            ) : (
              <div className="no-cards">
                <Icon>payment</Icon>
                <div>No payment methods found, please add a credit card.</div>
              </div>
            )}
            <Button data-cy="newCardBtn" className="new-card" onClick={openModal}>
              {buttonText}
            </Button>
          </React.Fragment>
        )}
      </StyledVaultedCards>
    );
  }
}

export const StyledVaultedCards = styled.div`
  margin: 40px 0;
  & .label {
    color: ${(props) => props.theme.text};
    display: flex;
    align-items: center;
    text-align: left;
    cursor: pointer;
  }
  & .remove button {
    text-align: right;
  }
  & .card-row {
    display: flex;
    align-items: center;
  }
  & .new-card,
  .confirm-payment {
    display: inherit;
    margin: 10px 0;
  }
  & .remove:hover,
  .new-card:hover {
    text-decoration: underline;
  }
  & .card-icon {
    margin-left: 12px;
  }
  & .no-cards {
    color: ${(props) => props.theme.text};
    text-align: center;
    margin: 50px;
  }
  & .no-cards svg {
    width: 35px;
    margin: 10px;
    fill: ${(props) => props.theme.text};
  }
  & .loading {
    width: 100%;
  }
  & .charge-info {
    color: ${(props) => props.theme.text};
    font-size: 17px;
    font-weight: 400;
    margin: 30px 0;
  }
  & .payment-totals div {
    width: 50%;
    text-align: left;
  }
  @media (max-width: 500px) {
    & .confirm-payment {
      width: 100%;
    }
  }
`;

VaultedCards.propTypes = {
  vaultedCards: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
  accountSelected: PropTypes.func.isRequired,
  selectedAccount: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.bool,
      PropTypes.object,
    ]),
  ).isRequired,
  openModal: PropTypes.func.isRequired,
  deleteCard: PropTypes.func.isRequired,
  deleteCardLoading: PropTypes.bool,
  addCardLoading: PropTypes.bool,
  vaultedCardsLoading: PropTypes.bool,
  submitOrder: PropTypes.func.isRequired,
  isSubmitPaymentLoading: PropTypes.bool.isRequired,
  totals: PropTypes.objectOf(PropTypes.string).isRequired,
  deliveryTipIsDisplayed: PropTypes.bool,
};

VaultedCards.defaultProps = {
  vaultedCards: [],
  deleteCardLoading: false,
  addCardLoading: false,
  vaultedCardsLoading: false,
  deliveryTipIsDisplayed: false,
};

export default VaultedCards;
